import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import styles from 'src/styles/common.module.scss'

export const TextHeaderEl = () => {
    return (
        <HighlightedText
            text="Συγχαρητήρια!"
            highlights={[{ word: 'Συγχαρητήρια!' }]}
            className={styles.text_header}
        />
    )
}

export const TextContentEl = () => {
    return (
        <HighlightedText
            text="ΚΕΡΔΙΣΑΤΕ 400 ΔΩΡΕΑΝ ΠΕΡΙΣΦΤΡΟΦΕΣ"
            highlights={[
                { word: '400' },
                { word: 'ΔΩΡΕΑΝ' },
                { word: 'ΠΕΡΙΣΦΤΡΟΦΕΣ' },
            ]}
            breakAfterWords={['ΚΕΡΔΙΣΑΤΕ', 'ΔΩΡΕΑΝ']}
            className={styles['text_content--SECOND']}
        />
    )
}
